import axios from 'axios'
import type {
  UserCreateRequest,
  UserCreateResponse,
  UserPaginatedRequest,
  UserPaginatedResponse,
  UserPatchRequest,
  UserRecoveryResponse,
  UserResponseDetailed,
} from 'types'

export const userList = (request: UserPaginatedRequest) =>
  axios
    .get<UserPaginatedResponse>('/api/users', { params: request })
    .then((res) => res.data)

export const userGet = (uuid: string) =>
  axios.get<UserResponseDetailed>(`/api/users/${uuid}`).then((res) => res.data)

export const userCreate = (request: UserCreateRequest) =>
  axios.post<UserCreateResponse>('/api/users', request).then((res) => res.data)

interface UserPatchPayload {
  uuid: string
  request: UserPatchRequest
}

export const userPatch = ({ uuid, request }: UserPatchPayload) =>
  axios
    .patch<UserResponseDetailed>(`/api/users/${uuid}`, request)
    .then((res) => res.data)

interface UserSetActivePayload {
  uuid: string
  active: boolean
}

export const userSetActive = ({ uuid, active }: UserSetActivePayload) =>
  active
    ? axios.post<void>(`/api/users/${uuid}/active`).then((res) => res.data)
    : axios.delete<void>(`/api/users/${uuid}/active`).then((res) => res.data)

interface UserSetArchivedPayload {
  uuid: string
  archived: boolean
}

export const userSetArchived = ({ uuid, archived }: UserSetArchivedPayload) =>
  archived
    ? axios.post<void>(`/api/users/${uuid}/archived`).then((res) => res.data)
    : axios.delete<void>(`/api/users/${uuid}/archived`).then((res) => res.data)

export const userRecover = (uuid: string) =>
  axios
    .post<UserRecoveryResponse>(`/api/users/${uuid}/recovery`)
    .then((res) => res.data)

export const userRetryRecoveryEmail = (uuid: string) =>
  axios
    .post<UserRecoveryResponse>(`/api/users/${uuid}/recovery-email`)
    .then((res) => res.data)

export interface UserGroupLink {
  userUuid: string
  groupUuid: string
}

export const userLinkGroup = ({ userUuid, groupUuid }: UserGroupLink) =>
  axios
    .post<void>(`/api/users/${userUuid}/groups/${groupUuid}`)
    .then((res) => res.data)

export const userUnlinkGroup = ({ userUuid, groupUuid }: UserGroupLink) =>
  axios
    .delete<void>(`/api/users/${userUuid}/groups/${groupUuid}`)
    .then((res) => res.data)

interface UserSetTwoFactorPayload {
  uuid: string
  enabled: boolean
}

export const userSetTwoFactor = ({ uuid, enabled }: UserSetTwoFactorPayload) =>
  enabled
    ? axios.post<void>(`/api/users/${uuid}/two-factor`).then((res) => res.data)
    : axios
        .delete<void>(`/api/users/${uuid}/two-factor`)
        .then((res) => res.data)
